import React, { useCallback, useMemo, useState } from 'react';
import { FC } from 'react';
import { useReport } from 'reports/pages/AddNewReport/AddNewReport';
import { Grid } from '@material-ui/core';
import IconCard from 'app/components/IconCard';
import styles from './TiktokAnalyzeChart.module.scss';
import { _t } from 'app/utils/i18n';
import {
  BigHeartIcon,
  CalenderIcon,
  EyeIcon,
  EyeTimeIcon,
  FollowerIcon,
  FollowingIcon,
  LanguageIcon,
  Resume,
  SubscribersIcon,
  UploadVideoIcon,
} from 'app/assets/images/icons';
import {
  entitiesApiRoutes,
  influencerApiRoutes,
} from 'influencers/utils/apiRoutes';
import BaseLine from 'app/components/Charts/BaseLine';
import SecondaryTable from 'app/components/Tables/SecondaryTable';
import FullCalendarBlock from 'influencers/components/FullCalendarBlock';
import { checkHoveringTranslated, checkTranslated } from 'app/utils/helpers';
import { nFormatter } from 'app/utils/numbersFormater';
import ToolTipComp from 'app/components/ToolTipComp';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { path } from 'app/utils/path';
import { useQuery, useQueryClient } from 'react-query';
import { useModal } from 'app/context/Modal';
import AddComment from 'reports/components/AddComment';
import DonutChart from 'app/components/Charts/DonutChart';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { savePrevSearchState, setSearchState } from 'app/utils/search-state';
import { extractTitleOrSubTileOrReportNameOrDesc } from 'reports/utils/utils';
import PrimaryMainTable from 'app/components/Tables/PrimaryMainTable';
import CardTitle from 'app/components/CardTitle';
import { getInfluencerRelatedInfluencers } from 'influencers/pages/RelatedInfluencers/Tables/InfluencerRelatedInfluencers';
import { getInfluencerRelatedEntities } from 'influencers/pages/RelatedInfluencers/Tables/InfluencerRelatedEntities';
import { getEntityRelatedInfluencers } from 'influencers/pages/RelatedInfluencers/Tables/EntityRelatedInfluencers';
import { getEntityRelatedEntities } from 'influencers/pages/RelatedInfluencers/Tables/EntityRelatedEntities';

const isEn = getFromLocalStorage('LNG') === 'en';

interface ITiktokAnalyzeChart {
  influencer_id: any;
  isReport?: boolean;
  isTemplate?: boolean;
  isInfluencerModule?: boolean;
  setActiveTab?: any;
  setOpenTab?: any;
  setlikesEngagementFilter?: any;
  openModalToAddinfluencer?: any;
  setInfluencerName?: any;
  youtubeData?: any;
  twitterData?: any;
  tweetData?: any;
  instagramData?: any;
  tab?: string;
  removeComments?: boolean;
  handelAnalyzedCalender?: any;
  InfluencerStatus?: string;
  items?: any[];
  twitter_profile_id?: number;
  instagram_profile_id?: number;
  channel_id?: number;
  linkedInData?: any;
  linkedin_profile_id?: number;
  is_full_grabbed?: boolean;
  tweet_id?: number;
  isEntity?: boolean;
  tiktok_profile_id?: any;
  tiktokData?: any;
}

export const checkDay = (days: any) => {
  if (days === 1) {
    return _t('influencers:day_ago');
  } else if (days === 0) {
    return '-';
  } else if (days === 2) {
    return _t('influencers:two_day_ago');
  } else {
    return isEn
      ? `${days} ${_t('influencers:days_ago')}`
      : `${_t('influencers:ago')} ${days} ${
          days > 10 ? _t('influencers:day') : _t('influencers:days')
        }`;
  }
};

const TiktokAnalyzeChart: FC<ITiktokAnalyzeChart> = ({
  influencer_id,
  isReport,
  setActiveTab,
  setOpenTab,
  isTemplate,
  isInfluencerModule,
  openModalToAddinfluencer,
  setInfluencerName,
  tab,
  removeComments,
  handelAnalyzedCalender,
  items,
  tiktokData,
  tiktok_profile_id,
}) => {
  const report = useReport() as any;
  const isInDownloadCharts = location.pathname.includes('download');
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const history = useHistory();
  const [addRepliesConvChartToReport, setAddRepliesConvChartToReport] =
    useState(false);
  const modal = useModal();
  const modules: string[] =
    queryClient.getQueryData('getAuthorizedModules') || [];
  const influencerDetails = queryClient.getQueryData<any>('influencerDetails');
  const isAr = getFromLocalStorage('LNG') === 'ar';
  const handelAuthorizationVideos = (data: any) => {
    modules.includes('VIDEOS')
      ? history.push(`${path.posts.YOUTUBE_POST_DETAILS_URI}/${data.video_id}`)
      : modal.show({
          isAlternative: true,
          message: _t('basic:you_are_not_authorize'),
        });
  };

  const tweetsChartSlug = useMemo(
    () =>
      isInfluencerModule
        ? influencerApiRoutes().twitterAnalyzedTweets
        : entitiesApiRoutes().twitterAnalyzedTweets,
    [isInfluencerModule],
  );
  const handelHashtagAuthorization = (data: any) => {
    modules.includes('HASHTAGS')
      ? history.push(
          `${path.hashtags.HASHTAG_VIEW_URI}/${
            data.hashtag_id
          }/${savePrevSearchState(
            checkTranslated(
              data?.hashtag_name?.original,
              data?.hashtag_name?.arabic,
            ),
          )}`,
        )
      : modal.show({
          isAlternative: true,
          message: _t(`basic:you_are_not_authorize`),
        });
  };

  const topWords = [
    {
      title: _t('basic:word'),
      key: 'word_name',
      render: (val: any, row: any) => (
        <div>
          {checkTranslated(row?.word_name?.original, row?.word_name?.arabic)}
        </div>
      ),
    },
    {
      title: _t('basic:usage'),
      key: 'word_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];
  const topHashtags = [
    {
      title: _t('trends:hashtag'),
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <a
          onClick={() => handelHashtagAuthorization(row)}
          className="cursor-pointer"
        >
          {checkTranslated(
            row?.hashtag_name?.original,
            row?.hashtag_name?.arabic,
          )}
        </a>
      ),
    },
    {
      title: _t('basic:mentions'),
      key: 'hashtag_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row?.hashtag_name?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.hashtag_name?.original,
                row?.hashtag_name?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> -</p>
          )}
        </>
      ),
    },
  ];
  const topAccountVideos = [
    {
      title: _t('trends:video'),
      key: 'content',
      render: (val: any, row: any) => (
        <div
          style={{
            maxWidth: '100px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
          title={checkTranslated(row?.content?.original, row?.content?.arabic)}
        >
          {checkTranslated(row?.content?.original, row?.content?.arabic)}
        </div>
      ),
    },
    {
      title: _t('basic:views'),
      key: 'play_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row?.content?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.content?.original,
                row?.content?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> -</p>
          )}
        </>
      ),
    },
  ];
  const topMentions = [
    {
      title: _t('basic:username'),
      key: 'username',
      render: (value: number, row: any) =>
        row?.influencer?.influencer_id === influencerDetails?.influencer_id ? (
          <></>
        ) : row?.influencer?.influencer_id != 0 ? (
          <Link
            to={`${
              row?.influencer?.is_entity
                ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                : row?.influencer?.is_influencer
                  ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                  : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
            }/${row?.influencer?.influencer_id}`}
          >
            {row?.influencer?.name?.original}
          </Link>
        ) : (
          <p
            onClick={() => {
              openModalToAddinfluencer(
                typeof row?.username === 'string'
                  ? row?.username
                  : row?.username?.original,
                row?.influencer?.url,
              );
              setInfluencerName(
                typeof row?.username === 'string'
                  ? row?.username
                  : row?.username?.original,
              );
            }}
            className="cursor-pointer"
          >
            {typeof row?.username === 'string'
              ? row?.username
              : row?.username?.original}
          </p>
        ),
    },
    {
      title: _t('influencers:number_of_mentions'),
      key: 'mentions_count',
      render: (value: number) => <p>{nFormatter(value)}</p>,
    },
  ];
  const checkIsReport = useCallback(
    (report: any, notReport: any = undefined) =>
      removeComments ? notReport : isReport && !isTemplate ? report : notReport,
    [isReport, isTemplate, removeComments],
  );
  // const addCommentComponent = useCallback(
  //   (slug: string) =>
  //     checkIsReport(
  //       <AddComment {...report} compId={slug} id={influencer_id} />,
  //     ),
  //   [checkIsReport, influencer_id, report],
  // );

  type TRenderCharts = { id: string; component: JSX.Element }[] | false;
  const checkIsTemplate = useMemo(
    () => isTemplate && !isReport,
    [isTemplate, isReport],
  );
  const customTiktokFilters = useMemo(
    () =>
      checkIsTemplate
        ? {
            influencer_id: influencer_id.tiktok,
            tiktok_profile_id,
            is_sample: true,
          }
        : { influencer_id, tiktok_profile_id },
    [influencer_id, checkIsTemplate, tiktok_profile_id],
  );

  const getItemCount = (slug: string) => {
    return items?.find((item) => item?.slug === slug)?.item_count;
  };
  const renderTiktokCharts: TRenderCharts = [
    {
      id: 'influencers_tiktok_analyze_followers',
      component: (
        <IconCard
          compId={'influencers_tiktok_analyze_followers'}
          withFilter={!isReport}
          title={
            _t('influencers:Followers') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          cardData={{
            icon: <FollowerIcon />,
            countName: 'Followers',
          }}
          customFilters={customTiktokFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().tiktokFollowersCount
              : entitiesApiRoutes().tiktokFollowersCount
          }
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_tiktok_analyze_followers'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_tiktok_analyze_following',
      component: (
        <IconCard
          withFilter={!isReport}
          compId={'influencers_tiktok_analyze_following'}
          title={
            _t('influencers:Following') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          cardData={{
            icon: <FollowingIcon />,
            countName: 'Follwing',
          }}
          customFilters={customTiktokFilters}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().tiktokFollowingCount
              : entitiesApiRoutes().tiktokFollowingCount
          }
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_tiktok_analyze_following'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_tiktok_analyze_likes',
      component:
        tiktokData?.likes_count === 0 ? (
          <></>
        ) : (
          <IconCard
            compId={'influencers_tiktok_analyze_likes'}
            withFilter={!isReport}
            hideInput
            title={
              _t('basic:likes') +
              ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
            }
            cardData={{
              icon: <BigHeartIcon />,
              count: tiktokData?.likes_count,
              // countName: 'times',
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_tiktok_analyze_likes'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ),
    },
    {
      id: 'influencers_tiktok_analyze_total_videos',
      component:
        tiktokData?.videos_count === 0 ? (
          <></>
        ) : (
          <IconCard
            compId={'influencers_tiktok_analyze_total_videos'}
            withFilter={!isReport}
            hideInput
            title={
              _t('videos:total_videos') +
              ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
            }
            cardData={{
              icon: <Resume />,
              count: tiktokData?.videos_count,
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            customFilters={customTiktokFilters}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_tiktok_analyze_total_videos'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ),
    },
    {
      id: 'influencers_tiktok_analyze_total_views',
      component: (
        <IconCard
          withFilter={!isReport}
          title={
            _t('influencers:total_views') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          cardData={{
            icon: <EyeIcon />,
            countName: 'views',
            count: tiktokData?.total_videos_views,
          }}
          customFilters={customTiktokFilters}
          compId={'influencers_tiktok_analyze_total_views'}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_tiktok_analyze_total_views'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_tiktok_analyze_diggs',
      component:
        tiktokData?.digg_count === 0 ? (
          <></>
        ) : (
          <IconCard
            compId={'influencers_tiktok_analyze_diggs'}
            withFilter={!isReport}
            hideInput
            title={
              _t('influencers:diggs') +
              ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
            }
            cardData={{
              icon: <BigHeartIcon />,
              count: tiktokData?.digg_count,
            }}
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_tiktok_analyze_diggs'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ),
    },
    // {
    //   id: 'influencers_tiktok_analyze_gained_followers',
    //   component: (
    //     <Grid item lg={8} sm={12}>
    //       <BaseLine
    //         compId={'influencers_tiktok_analyze_gained_followers'}
    //         baseLineTitle={
    //           _t('influencers:gained_followers') +
    //           ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
    //         }
    //         slugName={
    //           isInfluencerModule
    //             ? influencerApiRoutes().tiktokAnalyzedTweetsFollowersBaseLine
    //             : entitiesApiRoutes().tiktokAnalyzedTweetsFollowersBaseLine
    //         }
    //         customFilters={customTiktokFilters}
    //         withYearTime={isReport}
    //         timeIntervalFilter={!isReport}
    //         noDayInTimeInterval={!isReport}
    //         hideNames
    //         showDefaultTooltip
    //         additionalComponents={checkIsReport(
    //           <AddComment
    //             {...report}
    //             compId={'influencers_tiktok_analyze_gained_followers'}
    //             id={influencer_id}
    //           />,
    //         )}
    //         isReport={isReport}
    //       />
    //     </Grid>
    //   ),
    // },
    // {
    //   id: 'influencers_tiktok_analyze_uploaded_videos',
    //   component: (
    //     <Grid item lg={8} sm={12}>
    //       <BaseLine
    //         compId={'influencers_tiktok_analyze_uploaded_videos'}
    //         baseLineTitle={
    //           _t('influencers:uploaded_videos') +
    //           ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
    //         }
    //         slugName={
    //           isInfluencerModule
    //             ? influencerApiRoutes().tiktokAnalyzedTweetsFollowersBaseLine
    //             : entitiesApiRoutes().tiktokAnalyzedTweetsFollowersBaseLine
    //         }
    //         customFilters={customTiktokFilters}
    //         withYearTime={isReport}
    //         timeIntervalFilter={!isReport}
    //         noDayInTimeInterval={!isReport}
    //         hideNames
    //         showDefaultTooltip
    //         additionalComponents={checkIsReport(
    //           <AddComment
    //             {...report}
    //             compId={'influencers_tiktok_analyze_uploaded_videos'}
    //             id={influencer_id}
    //           />,
    //         )}
    //         isReport={isReport}
    //       />
    //     </Grid>
    //   ),
    // },
    {
      id: 'influencers_tiktok_analyze_post_calendar',
      component: (
        <Grid item lg={4} sm={12}>
          <FullCalendarBlock
            isInfluencerModule={isInfluencerModule}
            compId={'influencers_tiktok_analyze_post_calendar'}
            id={checkIsTemplate ? influencer_id.twitter : influencer_id}
            slug={'details/tiktok/calendar'}
            title={
              _t('influencers:linkedin_calendar') +
              ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
            }
            setActiveTab={setActiveTab}
            setOpenTab={setOpenTab}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_tiktok_analyze_post_calendar'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
            isTemplate={isTemplate}
            customFilters={{ tiktok_profile_id, is_sample: checkIsTemplate }}
            upToDate={handelAnalyzedCalender}
          />
        </Grid>
      ),
    },
    {
      id: 'influencers_tiktok_analyze_sentiment',
      component:
        influencerDetails?.status === 'ANALYZED' || isTemplate || isReport ? (
          <DonutChart
            donutTitle={
              _t('trends:sentiment') +
              ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
            }
            limit={5}
            showFilter
            withRefetch
            hideInput
            customFilters={customTiktokFilters}
            title={_t('influencers:posts')}
            compId={'influencers_tiktok_analyze_sentiment'}
            slug={
              isInfluencerModule
                ? influencerApiRoutes().tiktokSentiment
                : entitiesApiRoutes().tiktokSentiment
            }
            hideIfNoData={!isReport || isInDownloadCharts}
            grid={{
              lg: checkIsReport(4, 4),
              sm: 12,
            }}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_tiktok_analyze_sentiment'}
                id={influencer_id}
              />,
            )}
            isReport={isReport}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_tiktok_analyze_post_language',
      component: (
        <DonutChart
          donutTitle={
            _t('influencers:video_language') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          limit={5}
          showFilter
          hideInput
          customFilters={customTiktokFilters}
          title={_t('influencers:posts')}
          compId={'influencers_tiktok_analyze_post_language'}
          slug={
            isInfluencerModule
              ? influencerApiRoutes().tiktokLanguage
              : entitiesApiRoutes().tiktokLanguage
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          grid={{
            lg: checkIsReport(4, 4),
            sm: 12,
          }}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_tiktok_analyze_post_language'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_tiktok_analyze_top_words',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_words') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          compId={'influencers_tiktok_analyze_top_words'}
          columns={topWords}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().tiktokTopWords
              : entitiesApiRoutes().tiktokTopWords
          }
          hideFilters
          customFilters={customTiktokFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_tiktok_analyze_top_words'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_tiktok_analyze_top_hashtags',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_hashtags') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          expandAction={
            isReport || isTemplate
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(2);
                }
          }
          compId={'influencers_tiktok_analyze_top_hashtags'}
          columns={topHashtags}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().tiktokTopHashtags
              : entitiesApiRoutes().tiktokTopHashtags
          }
          hideFilters
          customFilters={customTiktokFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_tiktok_analyze_top_hashtags'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_tiktok_analyze_top_mentions',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_mentions') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          compId={'influencers_tiktok_analyze_top_mentions'}
          columns={topMentions}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().tiktokTopMentions
              : entitiesApiRoutes().tiktokTopMentions
          }
          hideFilters
          customFilters={customTiktokFilters}
          notPlatforms
          hideToggleView
          distributed
          hideCountry
          expandAction={
            isReport || isTemplate
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(3);
                }
          }
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={
                isInfluencerModule
                  ? 'influencers_tiktok_analyze_top_mentions'
                  : 'entities_tiktok_analyze_top_mentions'
              }
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
    {
      id: 'influencers_tiktok_analyze_top_account_videos',
      component: (
        <SecondaryTable
          grid={{ item: true, lg: 4, sm: 12 }}
          tableCardTitle={
            _t('influencers:top_Account') +
            ` ${isReport ? `( ${_t('reports:tiktok')} )` : ''}`
          }
          expandAction={
            isReport || isTemplate
              ? undefined
              : () => {
                  window.scrollTo(0, 0);
                  setActiveTab(1);
                  setOpenTab(0);
                  setSearchState({
                    filters: {
                      order_column: {
                        label: _t('influencers:most_play'),
                        value: 'play_count',
                      },
                    },
                  });
                }
          }
          compId={'influencers_tiktok_analyze_top_account_videos'}
          columns={topAccountVideos}
          moduleName={
            isInfluencerModule
              ? influencerApiRoutes().tiktokTopVideos
              : entitiesApiRoutes().tiktokTopVideos
          }
          hideFilters
          customFilters={customTiktokFilters}
          notPlatforms
          distributed
          hideToggleView
          hideIfNoData={!isReport || isInDownloadCharts}
          additionalComponents={checkIsReport(
            <AddComment
              {...report}
              compId={'influencers_tiktok_analyze_top_account_videos'}
              id={influencer_id}
            />,
          )}
          isReport={isReport}
        />
      ),
    },
  ];

  const isDownload = pathname.includes('charts/download');
  const relatedInfluencersColumns: TRenderCharts = [
    {
      id: 'influencers_related_influencers',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().allRelatedInfluencers
                : entitiesApiRoutes().allRelatedInfluencers
            }
            defaultTab={'allColumns'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.tiktok : +influencer_id,
                    true,
                  ).allColumns
                : getEntityRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).allColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'basic:all',
              )} )`}
              compId={'influencers_related_influencers'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_friend',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_friend'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().friendsRelatedInfluencers}
            defaultTab={'friends'}
            columns={
              getInfluencerRelatedInfluencers(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).friendsColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_friend')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_friend'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'influencers:friends',
              )} )`}
              compId={'influencers_related_influencers_friend'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_relative',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_relative'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().relativesRelatedInfluencers}
            defaultTab={'relatives'}
            columns={
              getInfluencerRelatedInfluencers(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).relativesColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_relative')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_relative'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'influencers:relatives',
              )} )`}
              compId={'influencers_related_influencers_relative'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_coworker',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_coworker'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().coworkersRelatedInfluencers
                : entitiesApiRoutes().coworkersRelatedInfluencers
            }
            defaultTab={'coworkers'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).coworkersColumns
                : getEntityRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).byOrganizationColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_coworker')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_coworker'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${
                isInfluencerModule
                  ? _t('influencers:coworkers')
                  : _t('basic:by_organization')
              } )`}
              compId={'influencers_related_influencers_coworker'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_mention',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_mention'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().mentionsRelatedInfluencers
                : entitiesApiRoutes().mentionsRelatedInfluencers
            }
            defaultTab={'mentions'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
                : getEntityRelatedInfluencers(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_influencers_mention')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_mention'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'basic:mentions',
              )} )`}
              compId={'influencers_related_influencers_mention'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().allRelatedEntities
                : entitiesApiRoutes().allRelatedEntities
            }
            defaultTab={'allEntities'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).allColumns
                : getEntityRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).allColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_entities')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${_t(
                'basic:all',
              )} )`}
              compId={'influencers_related_entities'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities_study_place',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities_study_place'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().schoolUniversityRelatedEntities}
            columns={
              getInfluencerRelatedEntities(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).schoolUniversityColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            defaultTab="school_university"
            rowsLimit={getItemCount('influencers_related_entities_study_place')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities_study_place'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${_t(
                'influencers:school_university',
              )} )`}
              compId={'influencers_related_entities_study_place'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_influencers_fellow_student',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_influencers_fellow_student'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={influencerApiRoutes().fellowStudentsInfluencers}
            columns={
              getInfluencerRelatedInfluencers(
                checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                true,
              ).fellowStudents
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            defaultTab="fellow_students"
            rowsLimit={getItemCount(
              'influencers_related_influencers_fellow_student',
            )}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_influencers_fellow_student'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('influencers:related_influencers')} ( ${_t(
                'influencers:fellow_students',
              )} )`}
              compId={'influencers_related_influencers_fellow_student'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities_workplace',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities_workplace'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().coworkersRelatedEntities
                : entitiesApiRoutes().coworkersRelatedEntities
            }
            defaultTab={'mentions'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).coworkersColumns
                : getEntityRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).byOrganizationColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_entities_workplace')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities_workplace'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${
                isInfluencerModule
                  ? _t('basic:workplace')
                  : _t('basic:by_organization')
              } )`}
              compId={'influencers_related_entities_workplace'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
    {
      id: 'influencers_related_entities_mention',
      component:
        isReport || isTemplate ? (
          <PrimaryMainTable
            compId={'influencers_related_entities_mention'}
            grid={{
              lg: isDownload ? 6 : 12,
              sm: 12,
              item: true,
            }}
            hideAllTap
            hideBulkActions
            hideCheckbox
            hideTopBar
            hidePagination
            hideIfNoData
            moduleName={
              isInfluencerModule
                ? influencerApiRoutes().mentionsRelatedEntities
                : entitiesApiRoutes().mentionsRelatedEntities
            }
            defaultTab={'mentions'}
            columns={
              isInfluencerModule
                ? getInfluencerRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
                : getEntityRelatedEntities(
                    checkIsTemplate ? +influencer_id?.twitter : +influencer_id,
                    true,
                  ).mentionsColumns
            }
            customRequiredFilters={{
              influencer_id: checkIsTemplate
                ? +influencer_id?.twitter
                : +influencer_id,
              is_sample: checkIsTemplate,
            }}
            rowsLimit={getItemCount('influencers_related_entities_mention')}
            additionalComponents={checkIsReport(
              <AddComment
                {...report}
                compId={'influencers_related_entities_mention'}
                id={influencer_id}
              />,
            )}
          >
            <CardTitle
              title={`${_t('entities:related_entities')} ( ${_t(
                'basic:mentions',
              )} )`}
              compId={'influencers_related_entities_mention'}
              hideIcon={true}
            />
          </PrimaryMainTable>
        ) : (
          <></>
        ),
    },
  ];

  const renderChartsList = (chartList: any) =>
    chartList.map((item: any, index: number) =>
      item?.component
        ? React.cloneElement(item.component, { key: item?.id || index })
        : null,
    );

  const renderPage = () => {
    //render influencers pages
    if (tab == 'tiktok')
      return renderChartsList(
        renderTiktokCharts.concat(relatedInfluencersColumns),
      );
    //render report & templates pages
    const renderCharts = renderTiktokCharts.concat(relatedInfluencersColumns);
    if (items) {
      const paragraph = items?.map((item) =>
        extractTitleOrSubTileOrReportNameOrDesc(item),
      );
      const chartsFilter = renderCharts?.map((item: any) =>
        items?.some((i: any) => i?.slug === item?.id)
          ? {
              ...item,
              order: items?.find((comp) => comp.slug === item.id)?.order,
            }
          : null,
      );

      return renderChartsList(
        [...chartsFilter, ...paragraph]
          .filter(Boolean)
          .sort((a, b) => a.order - b.order),
      );
    }

    if (isReport && report) return report?.renderCharts(renderCharts);
  };

  const memoizedRenderPage = useMemo(
    () => renderPage(),
    [tab, report, influencer_id, tiktokData, addRepliesConvChartToReport],
  );

  return <>{memoizedRenderPage}</>;
};
export default TiktokAnalyzeChart;
